import {AppState} from '../../reducers/index';
import {createSelector} from '@ngrx/store';
import * as fromFeedbackReducer from './feedback.reducer';
import {FeedbackComplaint} from './feedback.model';
import {truncateString} from "../../../interfaces/global.interface";

export const currentState = (state: AppState) => (state[fromFeedbackReducer.feedbacksFeatureKey]);

export const selectAllFeedbacks = createSelector(currentState, fromFeedbackReducer.selectAll);


export const selectModifiedFeedbacks = createSelector(selectAllFeedbacks, (feedbacks) => {
  return feedbacks.map((feedback) => {
    return {
      ...feedback,
      modFeedbackService: feedback?.service?.serviceName,
      modDescription: truncateString(feedback?.description, 50),
      modCitizenFullName: feedback?.unregisteredComplainant ? `${feedback?.unregisteredComplainant?.firstName} ${feedback?.unregisteredComplainant?.lastName}` : `${feedback?.publicServantComplainant?.firstName} ${feedback?.publicServantComplainant?.lastName}`,
      location: `${feedback?.country}, ${feedback?.region?.reginalName}`
    };
  });
});


export const selectModifiedFeedbacksByfeedBackUuid= (feedbackUniqueId: string) =>
  createSelector(selectModifiedFeedbacks, (feedback: FeedbackComplaint[]) => {
    return feedback.find((feedback) => feedback?.uniqueId === feedbackUniqueId);
  });
